export function useTranslations(translations = {}) {
    return function translate(key) {
        return translations[key] || key;
    };
}